
const HOST = {
  dev: {
    ADEncrypt: {
      env: 'dev',
      appCode: 'crm',
      appValue: 'crm',
    }
  },
  test: {
    ADEncrypt: {
      env: 'test',
      appCode: 'crm',
      appValue: 'crm',
    },
  },
  qa: {
    ADEncrypt: {
      env: 'test',
      appCode: 'crm',
      appValue: 'crm',
    },
  },
  dr: {
    ADEncrypt: {
      env:'dr',
      AppCode:'crm',
      AppValue:'crm-ad',
    },
  },
  prod: {
    ADEncrypt: {
      env: 'prod',
      appCode: 'crm',
      appValue: 'crm-ad',
    },
  }
}

export const env = HOST[process.env.VUE_APP_SERVER_ENV];
